export interface SurveyorRank {
  label: string;
  icon: string;
  color: string;
  bg: string;
  minRating: number;
  minJobs: number;
}

export const RANKS: SurveyorRank[] = [
  { label: 'Platinum', icon: '💎', color: '#7C3AED', bg: '#EDE9FE', minRating: 4.8, minJobs: 50 },
  { label: 'Gold',     icon: '🥇', color: '#B45309', bg: '#FEF3C7', minRating: 4.5, minJobs: 20 },
  { label: 'Silver',   icon: '🥈', color: '#475569', bg: '#F1F5F9', minRating: 4.0, minJobs: 10 },
  { label: 'Bronze',   icon: '🥉', color: '#92400E', bg: '#FDF2E9', minRating: 3.5, minJobs: 5 },
  { label: 'Starter',  icon: '🌱', color: '#065F46', bg: '#D1FAE5', minRating: 0,   minJobs: 0 },
];

function coerceNumber(value: unknown, fallback = 0): number {
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : fallback;
}

export function getSurveyorRank(ratingAverage: unknown, totalJobs: unknown): SurveyorRank {
  const rating = coerceNumber(ratingAverage);
  const jobs = coerceNumber(totalJobs);
  for (const rank of RANKS) {
    if (rating >= rank.minRating && jobs >= rank.minJobs) {
      return rank;
    }
  }
  return RANKS[RANKS.length - 1];
}

export function renderStars(rating: number, size = 16): string {
  const full = Math.floor(rating);
  const half = rating - full >= 0.5 ? 1 : 0;
  const empty = 5 - full - half;
  return '★'.repeat(full) + (half ? '½' : '') + '☆'.repeat(empty);
}
